.g{justify-content:center;}